import * as React from 'react';
import { UitkIcon } from 'uitk-react-icons';
import { UitkLink } from 'uitk-react-link';
import { classNames } from 'uitk-react-utils';
import { UitkText } from 'uitk-react-text';
import {
  UitkMessagingCard,
  UitkMessagingCardImageLayout,
  UitkMessagingCardMedia,
  UitkMessagingCardSection
} from 'uitk-react-messaging-cards';
import IconType from 'src/types/shared/icon';

interface MessagingCardIconAndLabelProps {
  icon: IconType;
  label: string;
  linkText: string;
  withBackground: boolean;
  classes?: string;
  handleClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  testid?: string;
  ariaLabel?: string;
}

export const MessagingCardIconAndLabel = ({
  icon,
  label,
  linkText,
  withBackground,
  classes,
  handleClick,
  testid,
  ariaLabel
}: MessagingCardIconAndLabelProps) => {
  const messageClasses = classNames({ [classes]: classes });

  return (
    <UitkMessagingCard imageLayout={UitkMessagingCardImageLayout.LEFT} className={messageClasses}>
      <UitkMessagingCardMedia withBackground={withBackground} aria-hidden={true}>
        <UitkIcon name={icon.id} id={`messaging-card-icon-${icon.id}`} description={icon.description} />
      </UitkMessagingCardMedia>
      <UitkMessagingCardSection>
        <UitkText size={300}>{label}</UitkText>
        <UitkLink>
          <button onClick={handleClick} data-test-id={testid} aria-label={ariaLabel}>
            {linkText}
          </button>
        </UitkLink>
      </UitkMessagingCardSection>
    </UitkMessagingCard>
  );
};
